import { api } from './client'

export interface OembedData {
  embed_url: string
  thumbnail_url: string
  title: string
}

export function fetchOembed(url: string): Promise<OembedData> {
  return api.get<OembedData>(`/oembed?url=${encodeURIComponent(url)}`)
}
